import { inject, Injectable } from '@angular/core';

import { forkJoin, from, map, Observable } from 'rxjs';

import { BaasAppState } from '@lvflanders/bar';
import { BarInitializedHook } from '@lvflanders/bar-ng';

import { _BaasInternalLayoutService } from './baas-internal-layout.service';
import { BarLayoutService } from './bar-layout/bar-layout.service';
import { BarLayoutInternalGvkService } from './bar-layout-internal-gvk.service';
import { _BarBurgerprofielEngine } from './burgerprofiel/bar-burgerprofiel-engine-provider';

@Injectable()
/** Lifecycle hook for layout module. */
export class BarLayoutInitializedHook implements BarInitializedHook {
    readonly #state = inject(BaasAppState);
    readonly #layoutLegacy = inject(BarLayoutService);
    readonly #gvk = inject(BarLayoutInternalGvkService);
    readonly #burgerprofielEngine = inject(_BarBurgerprofielEngine);

    readonly #internalLayoutService = inject(_BaasInternalLayoutService);
    // NOTE must occur after baas static initialized hook
    order = 3;
    _framework = true;

    run(): Observable<void> {
        if (this.#state.toepassing?.versie && !this.#layoutLegacy.appVersion$.getValue()) {
            this.#layoutLegacy.appVersion$.next(this.#state.toepassing.versie);
        }

        this.#internalLayoutService.init();

        return forkJoin([this.#burgerprofielEngine.tryInitialize(), from(this.#gvk.preInit())]).pipe(map(() => undefined));
    }
}
